import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors } from '../styles';
import { RequiredBadge } from './required_badge';
export const InputButtonTypeRadioButton = (props) => {
    const { classObject, items, currentValue, label, isHalfTile, setCurrentValue } = props;
    const onClick = (v) => {
        const value = currentValue === v ? null : v;
        setCurrentValue(value);
    };
    return (React.createElement("div", { className: css(styles.container, classObject) },
        label && (React.createElement("div", { className: css(styles.label) },
            label,
            props.required && React.createElement(RequiredBadge, null))),
        React.createElement("div", { className: css(styles.radioButtonContainer) }, items.map(({ name, value, description }, index) => (React.createElement("div", { className: css(styles.radioButton, isHalfTile ? styles.itemWrapHalf : styles.itemWrapFull, value === currentValue ? styles.radioButtonOn : styles.radioButtonOff, props.hasValidationError && styles.validationError), onClick: () => onClick(value), key: index },
            React.createElement("div", { className: css(styles.name) }, name),
            description && React.createElement("div", { className: css(styles.descriptionText) }, description))))),
        props.validationErrorMessage && (React.createElement("div", { className: css(styles.validationErrorMessage) }, props.validationErrorMessage))));
};
const styles = StyleSheet.create({
    container: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    label: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        fontSize: 14,
        color: Colors.GrayDarkest,
        marginBottom: 8,
    },
    radioButtonContainer: {
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        gap: 8,
    },
    itemWrapFull: {
        width: '100%',
        boxSizing: 'border-box',
    },
    itemWrapHalf: {
        width: 'calc((100% - 8px) / 2)',
        boxSizing: 'border-box',
    },
    radioButton: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 50,
        width: '100%',
        borderRadius: 4,
        cursor: 'pointer',
    },
    radioButtonOn: {
        color: Colors.White,
        backgroundColor: Colors.PrimaryDark,
        border: `1px solid ${Colors.PrimaryDark}`,
    },
    radioButtonOff: {
        color: Colors.GrayDarkest,
        border: `1px solid ${Colors.Gray}`,
    },
    name: {
        fontSize: 12,
        fontWeight: 'bold',
    },
    descriptionText: {
        fontSize: 10,
    },
    validationError: {
        border: `1px solid ${Colors.Alert}`,
    },
    validationErrorMessage: {
        marginTop: 4,
        color: Colors.Alert,
        fontSize: 12,
        fontWeight: 400,
        lineHeight: '160%',
        letterSpacing: 0.48,
    },
});
